<template>
  <div>
    <Row :gutter="8" class="p-b-10">
      <!-- <i-col span="12">
        <Input size="small" v-model.trim="query.keyword" placeholder="项目名称" />
      </i-col> -->
      <i-col span="12">
        <Button  size="small" type="primary" icon="ios-search" @click="handleSearch">刷新列表</Button>
        <Button  size="small" type="success" icon="md-add" class="m-l-5" @click="handleCreate">新建</Button>
      </i-col>
    </Row>

    <Table size="small" :data="list" :columns="titles" stripe></Table>
    <div class="paging_style">
      <Page size="small" :total="total" :page-size="query.pageSize" show-total show-elevator :current="query.pageNum" @on-change="changePage"></Page>
    </div>

    <create-component ref="createFile"></create-component>
  </div>
</template>

<script>
import { getExprotPage } from '@/api/dw/platform'
import createComponent from './create'

export default {
  name: 'exprotPageComponent',
  components: {
    createComponent
  },
  data () {
    return {
      total: 0,
      query: {
        pageNum: 1,
        pageSize: 15,
        keyword: '',
        publisherId: this.$store.getters.token.userInfo.publisherId
      },
      list: [],
      titles: [
        { title: '编号', key: 'id', align: 'center', width: 80 },
        { title: '所属项目', key: 'projectName', align: 'center' },
        { title: '数据类型', key: 'opTypeStr', align: 'center' },
        { title: '文件类型', key: 'fileTypeLabel', align: 'center' },
        { title: '数据条件', key: 'conditions', align: 'center' },
        { title: '申请时间', key: 'createTime', align: 'center' },
        { title: '完成时间', key: 'finishTime', align: 'center' },
        {
          title: '状态',
          align: 'center',
          width: 100,
          render: (h, params) => {
            return h('Tag', {
              props: {
                color: params.row.status === 3 ? 'success' : 'default'
              }
            }, params.row.statusStr)
          }
        },
        {
          title: '操作',
          align: 'center',
          width: 200,
          render: (h, params) => {
            // 判断是否禁用下载按钮：状态不等于3或fileKey为空时禁用
            const isDisabled = params.row.status !== 3 || !params.row.fileKey

            return h('div', [
              h('Button', {
                props: {
                  size: 'small',
                  type: 'primary',
                  disabled: isDisabled
                },
                style: {
                  marginRight: '5px',
                  // 当禁用时使用灰色样式
                  ...(isDisabled && {
                    backgroundColor: '#f5f5f5',
                    borderColor: '#d9d9d9',
                    color: '#999'
                  })
                },
                on: {
                  click: () => {
                    if (!isDisabled) {
                      this.handleDownload(params.row)
                    }
                  }
                }
              }, '下载文档')
            ])
          }
        }
      ]
    }
  },
  methods: {
    getPageData () {
      getExprotPage(this.query).then(response => {
        // 处理返回数据
        this.list = response.data.records.map(item => {
          // 格式化数据范围
          const dataRange = `${item.startDate} ~ ${item.endDate}`

          // 格式化文件类型
          const fileTypeLabel = item.fileType === 1 ? 'Excel文件' : '附件文件'

          // 格式化数据类型
          const dataTypeLabel = item.dataType || ''

          return {
            ...item,
            dataRange,
            fileTypeLabel,
            dataTypeLabel
          }
        })

        this.total = response.data.total
        this.query.pageNum = response.data.current || this.query.pageNum
      }).catch(error => {
        this.$Notice.error({
          title: '获取数据失败',
          desc: error.message || '未知错误'
        })
      })
    },
    reloadData () {
      this.query.pageNum = 1
      this.getPageData()
    },
    changePage (currentPage) {
      this.query.pageNum = currentPage
      this.getPageData()
    },
    handleCreate () {
      this.$refs.createFile.showModal()
    },

    handleDownload (row) {
      if (!row.fileKey) {
        this.$Notice.warning({
          title: '下载失败',
          desc: '文件地址不存在'
        })
        return
      }

      try {
        // 创建隐藏的下载链接
        const link = document.createElement('a')
        link.href = row.fileKey // fileKey 是完整的 HTTPS 地址
        link.download = row.fileName
        link.style.display = 'none'

        // 添加到DOM并触发点击
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)

        this.$Notice.success({
          title: '下载开始',
          desc: `正在下载文件: ${row.fileName}`
        })
      } catch (error) {
        this.$Notice.error({
          title: '下载失败',
          desc: '文件下载失败: ' + (error.message || '未知错误')
        })
      }
    },

    delete (para) {
      this.$Modal.confirm({
        title: '操作提示',
        content: '<p>确定要删除该导出记录: ' + para.row.projectName + '(' + para.row.dataTypeLabel + ')，删除后将不可恢复！</p>',
        loading: true,
        onOk: () => {
          // TODO: 实现删除API
          setTimeout(() => {
            this.$Notice.success({ desc: '删除成功！' })
            this.list.splice(para.index, 1)
            this.$Modal.remove()
          }, 1000)
        },
        onCancel: () => {
          this.$Modal.remove()
        }
      })
    },

    handleSearch () {
      // this.query.pageNum = 1
      this.getPageData()
    }
  },
  created () {
    this.getPageData()
  },
  computed: {
    beginUpdate () {
      return this.$store.state.dataUpload.beginUpdate
    }
  },
  watch: {
    beginUpdate () {
      this.reloadData()
    }
  }
}
</script>
